import {
  CompanyName,
  CompanyPhoneNumber,
  FACEBOOK_BUSINESS_URL,
  FULL_BUSINESS_URL,
  INSTAGRAM_BUSINESS_URL,
  LINKEDIN_BUSINESS_URL,
} from '../Constants';

/* Index (Entrance) page */
export const indexPageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'Enter - Mistress Diva',
  url: `${FULL_BUSINESS_URL}/`,
  description:
    `Entrance to ${CompanyName}. Adults 18+ only. By entering, you confirm you understand and accept the site’s terms and age requirements.`,
  potentialAction: {
    '@type': 'SearchAction',
    target: `${FULL_BUSINESS_URL}/?s={search_term_string}`,
    'query-input': 'required name=search_term_string',
  },
  sameAs: [FACEBOOK_BUSINESS_URL, INSTAGRAM_BUSINESS_URL, LINKEDIN_BUSINESS_URL],
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: CompanyPhoneNumber,
    contactType: 'Customer Service',
    areaServed: ['GB', 'US', 'AU'],
    availableLanguage: ['English'],
  },
};

export const indexPageAdditionalMeta = [
  { property: 'og:title', content: 'Enter | Mistress Diva' },
  {
    property: 'og:description',
    content:
      'Adults 18+ only. Enter to access Mistress Diva’s official site. By entering you agree to the terms and age requirements.',
  },
  { property: 'og:image', content: `${FULL_BUSINESS_URL}/assets/images/mistress-diva-index.jpg` },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/` },
  { name: 'twitter:card', content: 'summary_large_image' },
  { name: 'twitter:title', content: 'Enter | Mistress Diva' },
  {
    name: 'twitter:description',
    content:
      'Entrance to the official site of Mistress Diva. Adults 18+ only. Continue to agree to the terms.',
  },
  { name: 'twitter:image', content: `${FULL_BUSINESS_URL}/assets/images/mistress-diva-index.jpg` },
];

/* Home page */
export const homePageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'Home - Mistress Diva',
  url: `${FULL_BUSINESS_URL}/home`,
  description:
    `Welcome to ${CompanyName}, Supreme Goddess of Erotic Elegance and Stern Discipline. Enter My realm and let Me turn your deepest desires into a reality.`,
  potentialAction: {
    '@type': 'SearchAction',
    target: `${FULL_BUSINESS_URL}/home?s={search_term_string}`,
    'query-input': 'required name=search_term_string',
  },
  sameAs: [FACEBOOK_BUSINESS_URL, INSTAGRAM_BUSINESS_URL, LINKEDIN_BUSINESS_URL],
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: CompanyPhoneNumber,
    contactType: 'Customer Service',
    areaServed: ['GB', 'US', 'AU'],
    availableLanguage: ['English'],
  },
};

export const homePageAdditionalMeta = [
  { property: 'og:title', content: 'Home - Mistress Diva' },
  {
    property: 'og:description',
    content:
      'Mistress Diva — Supreme Goddess of Erotic Elegance and Stern Discipline. Welcome to My domain where your deepest desires become reality.',
  },
  { property: 'og:image', content: `${FULL_BUSINESS_URL}/assets/images/mistress-diva-home.jpg` },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/home` },
  { name: 'twitter:card', content: 'summary_large_image' },
  { name: 'twitter:title', content: 'Home - Mistress Diva' },
  {
    name: 'twitter:description',
    content:
      'Enter the domain of Mistress Diva and experience bespoke, discreet BDSM sessions crafted to your desires.',
  },
  { name: 'twitter:image', content: `${FULL_BUSINESS_URL}/assets/images/mistress-diva-home.jpg` },
];

// Reviews page
export const reviewsPageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'CollectionPage',
  name: 'Reviews - Mistress Diva',
  url: `${FULL_BUSINESS_URL}/reviews`,
  description:
    'Read authentic reviews and testimonials for Mistress Diva from satisfied clients. Explore detailed feedback on bespoke BDSM sessions and professional, discreet service.',
  potentialAction: {
    '@type': 'SearchAction',
    target: `${FULL_BUSINESS_URL}/reviews?s={search_term_string}`,
    'query-input': 'required name=search_term_string',
  },
  sameAs: [FACEBOOK_BUSINESS_URL, INSTAGRAM_BUSINESS_URL, LINKEDIN_BUSINESS_URL],
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: CompanyPhoneNumber,
    contactType: 'Customer Service',
    areaServed: 'GB',
    availableLanguage: ['English'],
  },
  aggregateRating: {
    '@type': 'AggregateRating',
    ratingValue: '4.9',
    reviewCount: '127',
  },
};

export const reviewsPageAdditionalMeta = [
  { property: 'og:title', content: 'Reviews & Testimonials - Mistress Diva' },
  {
    property: 'og:description',
    content:
      'Explore real client reviews of Mistress Diva—discreet, professional BDSM experiences tailored to your desires.',
  },
  {
    property: 'og:image',
    content: `${FULL_BUSINESS_URL}/assets/images/mistress-diva-reviews.jpg`,
  },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/reviews` },
  { name: 'twitter:card', content: 'summary_large_image' },
  { name: 'twitter:title', content: 'Reviews & Testimonials - Mistress Diva' },
  {
    name: 'twitter:description',
    content:
      'Read testimonials from clients who experienced Mistress Diva’s bespoke, professional BDSM sessions.',
  },
  {
    name: 'twitter:image',
    content: `${FULL_BUSINESS_URL}/assets/images/mistress-diva-reviews.jpg`,
  },
];

// About page
export const aboutPageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'About Me - Mistress Diva',
  url: `${FULL_BUSINESS_URL}/about`,
  description: `Learn more about Mistress Diva, a professional dominatrix offering personalized BDSM sessions in the UK. With years of experience, she provides a unique and expert approach to domination.`,
  potentialAction: {
    '@type': 'SearchAction',
    target: `${FULL_BUSINESS_URL}/about?s={search_term_string}`,
    'query-input': 'required name=search_term_string',
  },
  sameAs: [`${FACEBOOK_BUSINESS_URL}`, `${INSTAGRAM_BUSINESS_URL}`],
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: `${CompanyPhoneNumber}`,
    contactType: 'Customer Service',
    areaServed: 'GB',
    availableLanguage: ['English'],
  },
};
export const aboutPageAdditionalMeta = [
  { property: 'og:title', content: `About Mistress Diva` },
  {
    property: 'og:description',
    content:
      'Discover more about Mistress Diva, an expert in the art of domination, offering bespoke sessions to fulfill your deepest desires.',
  },
  {
    property: 'og:image',
    content: `${FULL_BUSINESS_URL}/assets/images/mistress-diva-about.jpg`,
  }, // Use an appropriate image for the About page
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/about` },
  { name: 'twitter:card', content: 'summary_large_image' },
  { name: 'twitter:title', content: `About Mistress Diva` },
  {
    name: 'twitter:description',
    content:
      "Explore Mistress Diva's world of personalized BDSM experiences, providing expert guidance and unmatched services.",
  },
  {
    name: 'twitter:image',
    content: `${FULL_BUSINESS_URL}/assets/images/mistress-diva-about.jpg`,
  }, // Use an appropriate image for the About page
];
// Opportunities Page
export const opportunitiesPageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'Opportunities - Mistress Diva',
  url: `${FULL_BUSINESS_URL}/opportunities`,
  description: `Mistress Diva, an international professional dominatrix, is seeking private, discreet locations for sessions and may offer submissive opportunities at her discretion.`,
  potentialAction: {
    '@type': 'SearchAction',
    target: `${FULL_BUSINESS_URL}/opportunities?s={search_term_string}`,
    'query-input': 'required name=search_term_string',
  },
  sameAs: [`${FACEBOOK_BUSINESS_URL}`, `${INSTAGRAM_BUSINESS_URL}`],
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: `${CompanyPhoneNumber}`,
    contactType: 'Customer Service',
    areaServed: ['AU', 'GB', 'US'],
    availableLanguage: ['English'],
  },
};
export const opportunitiesPageAdditionalMeta = [
  { property: 'og:title', content: 'Opportunities with Mistress Diva' },
  {
    property: 'og:description',
    content:
      'Mistress Diva seeks private locations for discreet BDSM sessions and may offer service opportunities to select individuals. Apply respectfully.',
  },
  {
    property: 'og:image',
    content: `${FULL_BUSINESS_URL}/assets/images/mistress-diva-opportunities.jpg`,
  }, // Replace with the actual image path
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/opportunities` },
  { name: 'twitter:card', content: 'summary_large_image' },
  { name: 'twitter:title', content: 'Opportunities with Mistress Diva' },
  {
    name: 'twitter:description',
    content:
      'Discreet spaces wanted for private BDSM sessions. Mistress Diva may also offer service roles to suitable applicants. Email for more.',
  },
  {
    name: 'twitter:image',
    content: `${FULL_BUSINESS_URL}/assets/images/mistress-diva-opportunities.jpg`,
  }, // Replace with actual image path
];

// Gallery page
export const galleryPageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'Gallery - Mistress Diva',
  url: `${FULL_BUSINESS_URL}/gallery`,
  description: `Explore the gallery of Mistress Diva, a professional dominatrix offering personalized BDSM experiences. Her carefully curated gallery showcases scenes and moments that highlight her expertise in domination, artful submission, and intimate, tailored experiences.`,
  potentialAction: {
    '@type': 'SearchAction',
    target: `${FULL_BUSINESS_URL}/gallery?s={search_term_string}`,
    'query-input': 'required name=search_term_string',
  },
  sameAs: [`${FACEBOOK_BUSINESS_URL}`, `${INSTAGRAM_BUSINESS_URL}`],
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: `${CompanyPhoneNumber}`,
    contactType: 'Customer Service',
    areaServed: 'GB',
    availableLanguage: ['English'],
  },
};

export const galleryPageAdditionalMeta = [
  { property: 'og:title', content: `Gallery - Mistress Diva` },
  {
    property: 'og:description',
    content:
      'Discover the gallery of Mistress Diva, an expert in BDSM, showcasing carefully curated images that reveal her expertise in domination and intimate experiences.',
  },
  {
    property: 'og:image',
    content: `${FULL_BUSINESS_URL}/assets/images/mistress-diva-gallery.jpg`,
  }, // Use an appropriate image for the Gallery page
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/gallery` },
  { name: 'twitter:card', content: 'summary_large_image' },
  { name: 'twitter:title', content: `Gallery - Mistress Diva` },
  {
    name: 'twitter:description',
    content:
      "Explore Mistress Diva's gallery showcasing her unique approach to BDSM, with images highlighting her dominance and expert guidance.",
  },
  {
    name: 'twitter:image',
    content: `${FULL_BUSINESS_URL}/assets/images/mistress-diva-gallery.jpg`,
  }, // Use an appropriate image for the Gallery page
];

// Services page
export const servicesPageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'Services - Mistress Diva',
  url: `${FULL_BUSINESS_URL}/services`,
  description: `Explore the personalized BDSM services provided by Mistress Diva, a professional dominatrix offering a variety of tailored sessions in the UK. With years of experience, Mistress Diva crafts unique and intimate experiences to meet the specific desires and boundaries of each individual.`,
  potentialAction: {
    '@type': 'SearchAction',
    target: `${FULL_BUSINESS_URL}/services?s={search_term_string}`,
    'query-input': 'required name=search_term_string',
  },
  sameAs: [`${FACEBOOK_BUSINESS_URL}`, `${INSTAGRAM_BUSINESS_URL}`],
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: `${CompanyPhoneNumber}`,
    contactType: 'Customer Service',
    areaServed: 'GB',
    availableLanguage: ['English'],
  },
};

export const servicesPageAdditionalMeta = [
  { property: 'og:title', content: `Services - Mistress Diva` },
  {
    property: 'og:description',
    content:
      'Discover the professional services offered by Mistress Diva, a skilled dominatrix providing tailored BDSM sessions designed for your unique desires and experiences.',
  },
  {
    property: 'og:image',
    content: `${FULL_BUSINESS_URL}/assets/images/mistress-diva-services.jpg`,
  }, // Use an appropriate image for the Services page
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/services` },
  { name: 'twitter:card', content: 'summary_large_image' },
  { name: 'twitter:title', content: `Services - Mistress Diva` },
  {
    name: 'twitter:description',
    content:
      'Explore tailored BDSM services offered by Mistress Diva, designed to provide intimate and unique experiences for her clients.',
  },
  {
    name: 'twitter:image',
    content: `${FULL_BUSINESS_URL}/assets/images/mistress-diva-services.jpg`,
  }, // Use an appropriate image for the Services page
];

// Maintenance
export const maintenancePageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'Maintenance Page',
  description: `The ${CompanyName} website is currently undergoing maintenance. We’ll be back soon!`,
  url: `${FULL_BUSINESS_URL}/maintenance`,
};

export const maintenancePageAdditionalMeta = [
  { property: 'og:title', content: `We'll Be Back Soon - ${CompanyName}` },
  {
    property: 'og:description',
    content: `The ${CompanyName} website is currently undergoing maintenance. We’ll be back shortly with exciting updates.`,
  },
  {
    property: 'og:image',
    content: `${FULL_BUSINESS_URL}/assets/images/pages/maintenance-preview.jpg`,
  },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/maintenance` },
  { name: 'twitter:card', content: 'summary_large_image' },
  { name: 'twitter:title', content: `We'll Be Back Soon - ${CompanyName}` },
  {
    name: 'twitter:description',
    content: `The ${CompanyName} website is currently undergoing maintenance. We’ll be back shortly with exciting updates.`,
  },
  {
    name: 'twitter:image',
    content: `${FULL_BUSINESS_URL}/assets/images/pages/maintenance-preview.jpg`,
  },
];

// Policies page
export const termsAndPoliciesStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'Terms and Policies',
  description: `Explore the terms of service and privacy policies of ${CompanyName}.`,
  url: `${FULL_BUSINESS_URL}/terms-and-policies`,
  mainEntity: {
    '@type': 'FAQPage',
    name: 'Terms and Policies FAQ',
    description: `Frequently asked questions about terms of service, privacy policies, and compliance at ${CompanyName}.`,
  },
};

export const termsAndPoliciesAdditionalMeta = [
  { property: 'og:title', content: `Terms and Policies - ${CompanyName}` },
  {
    property: 'og:description',
    content: `Understand the terms of service, privacy policies, and compliance guidelines of ${CompanyName}.`,
  },
  {
    property: 'og:image',
    content: `${FULL_BUSINESS_URL}/assets/images/pages/terms-preview.jpg`,
  },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/terms-and-policies` },
  { name: 'twitter:card', content: 'summary_large_image' },
  { name: 'twitter:title', content: `Terms and Policies - ${CompanyName}` },
  {
    name: 'twitter:description',
    content: `Learn more about our terms of service, privacy policies, and compliance at ${CompanyName}.`,
  },
  {
    name: 'twitter:image',
    content: `${FULL_BUSINESS_URL}/assets/images/pages/terms-preview.jpg`,
  },
];

// Error page
export const errorPageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: '404 Error Page',
  description: `The requested page could not be found on ${CompanyName}.`,
  url: `${FULL_BUSINESS_URL}/404`,
  potentialAction: {
    '@type': 'SearchAction',
    target: `${FULL_BUSINESS_URL}/?s={search_term_string}`,
    'query-input': 'required name=search_term_string',
  },
};

export const errorPageAdditionalMeta = [
  { property: 'og:title', content: 'Page Not Found - 404' },
  {
    property: 'og:description',
    content: `Oops! The page you’re looking for isn’t here. Visit ${CompanyName} to find what you need.`,
  },
  {
    property: 'og:image',
    content: `${FULL_BUSINESS_URL}/assets/images/pages/404-preview.jpg`,
  },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/404` },
  { name: 'twitter:card', content: 'summary_large_image' },
  { name: 'twitter:title', content: 'Page Not Found - 404' },
  {
    name: 'twitter:description',
    content: `Oops! The page you’re looking for isn’t here. Visit ${CompanyName} to find what you need.`,
  },
  {
    name: 'twitter:image',
    content: `${FULL_BUSINESS_URL}/assets/images/pages/404-preview.jpg`,
  },
];

// Contact page
export const contactPageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'ContactPage',
  mainEntity: {
    '@type': 'Organization',
    name: CompanyName,
    url: FULL_BUSINESS_URL,
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: CompanyPhoneNumber,
      contactType: 'Customer Service',
      areaServed: 'GB',
      availableLanguage: ['English'],
    },
    sameAs: [
      FACEBOOK_BUSINESS_URL,
      INSTAGRAM_BUSINESS_URL,
      LINKEDIN_BUSINESS_URL,
    ],
    logo: {
      '@type': 'ImageObject',
      url: `${FULL_BUSINESS_URL}/brand/logo.png`,
    },
  },
};

export const contactPageAdditionalMeta = [
  { property: 'og:title', content: `Contact ${CompanyName}` },
  {
    property: 'og:description',
    content: `Reach out to ${CompanyName} for professional web and circuit design solutions. We're ready to discuss your projects and answer any questions.`,
  },
  {
    property: 'og:image',
    content: `${FULL_BUSINESS_URL}/brand/contact-preview.jpg`,
  },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/contact` },
  { name: 'twitter:card', content: 'summary_large_image' },
  { name: 'twitter:title', content: `Contact ${CompanyName}` },
  {
    name: 'twitter:description',
    content: `Contact ${CompanyName} for expert web and circuit design services. Let's discuss your needs and find the best solution.`,
  },
  {
    name: 'twitter:image',
    content: `${FULL_BUSINESS_URL}/brand/contact-preview.jpg`,
  },
];
